import { render, staticRenderFns } from "./data21.vue?vue&type=template&id=7dac784b&scoped=true&"
import script from "./data21.vue?vue&type=script&lang=js&"
export * from "./data21.vue?vue&type=script&lang=js&"
import style1 from "./data21.vue?vue&type=style&index=1&id=7dac784b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dac784b",
  null
  
)

export default component.exports